<!-- Claim Bill (837 Professional) -->
<div *ngIf="Profession">
    <div widget class="card border-0 box-shadow">
        <div class="card-header transparent text-muted row">
            <h4 class="font-header col-lg-10 col-md-10 col-sm-6 col-xs-6">
                Claim Bill (837 Professional)
            </h4>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-right">
                <button class="btn blue-btn btn-sm" [disabled]="true">
                    <i class="fa fa-print" aria-hidden="true"></i>
                    Print
                </button>
            </div>
        </div>
        <div class="col-12 mt-3 p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body transparent">
                    <div class="row">
                        <div class="col-lg-3 col-md-2 col-sm-12 col-xs-12 line">
                            <label>Payer:&nbsp;&nbsp;{{ ProfessionClaimList.payerName }}</label><br />
                            <label>Total charges:&nbsp;&nbsp;$
                                {{ ProfessionClaimList.totalcharges }}</label><br />
                            <label>Total Gross charges:&nbsp;&nbsp;$
                                {{ ProfessionClaimList.grossCharge }}</label><br />
                            <label>Amount Paid:&nbsp;&nbsp;$
                                {{ ProfessionClaimList.amountPaid }}</label><br />
                            <label>Balance Due:&nbsp;&nbsp;$
                                {{ ProfessionClaimList.balanceDue }}</label>

                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 line">
                            <div class="row ms-7 mt-22">
                                <div class=" col-lg-4 col-md-4 col-sm-12 col-xs-12"><label class="label">Resubmission
                                        code</label></div>
                                <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12" style="display: flex;">
                                    <select [(ngModel)]="ProfessionClaimList.resubmissionLid"
                                        [disabled]="showEditorView"
                                        class="form-control col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                        <option [value]="st.id" *ngFor="let st of ResubmissionList">
                                            {{ st.lovName }}
                                        </option>
                                    </select>
                                    <app-dropdown *ngIf="!showEditorView"
                                        (EmitRefreshClick)="refreshToGetDropDownValues('RESUBMISSION')"></app-dropdown>
                                </div>
                            </div>
                            <div class="row ms-7 mt-12">
                                <div class=" col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <label class="label ">Payer Claim Control #</label>
                                </div>
                                <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12">

                                    <input type="text" class="form-control "
                                        [(ngModel)]="ProfessionClaimList.payerClaimControl"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <br />
                            <div class="row ms-7 mt-12">
                                <div class=" col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                    <label class="label">Note</label>
                                </div>
                                <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12">

                                    <textarea class="form-control" [(ngModel)]="ProfessionClaimList.note"
                                        [disabled]="showEditorView"></textarea>
                                </div>
                            </div>

                            <div class="row ms-7 mt-22">
                                <div class="col">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                            <label class="label">Alter Claim Status</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12" style="display: flex;">

                                            <select [(ngModel)]="ProfessionClaimList.claimMasterStatusLid"
                                                [disabled]="showEditorView" class="form-control ">
                                                <option></option>
                                                <option [value]="ACS.id" *ngFor="let ACS of AlterClaimsStatus">
                                                    {{ ACS.lovName }}
                                                </option>
                                            </select>
                                            <app-dropdown *ngIf="!showEditorView"
                                                (EmitRefreshClick)="refreshToGetDropDownValues('ALTERCLAIMSTATUS')"></app-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                            <div class="row ">
                                <button class="btn blue-btn btn-sm ms-3 mt-1 col-lg-3"
                                    (click)="updateProfessionalClaim('success')" *ngIf="!update">
                                    Update
                                </button>
                                <button class="btn blue-btn btn-sm ms-3 mt-1 col-lg-2" (click)="BacktoClaimsList()">
                                    Close
                                </button>
                                <button class="btn blue-btn btn-sm ms-3 mt-1 col-lg-3" (click)="checkboxFunction()"
                                    *ngIf="isInputOptions.tabsChanges == 'ActiveClaims' || isInputOptions.tabsChanges == 'ArchiveClaims'">
                                    Edit
                                </button>
                            </div>
                            <div class="row mt-4 ps-3">
                                <button class="btn blue-btn btn-sm col-lg-4"
                                    *ngIf="isInputOptions.tabsChanges == 'ActiveClaims' || isInputOptions.tabsChanges == 'ArchiveClaims'"
                                    data-bs-toggle="modal" data-bs-target="#claimHistoryModal"
                                    (click)="showClaimHistory()">Claim
                                    History</button>
                                <button class="btn blue-btn btn-sm ms-3 col-lg-4"
                                    *ngIf="(isInputOptions.tabsChanges == 'ActiveClaims' || isInputOptions.tabsChanges == 'ArchiveClaims') && isInputOptions.isClaimAttachment"
                                    (click)="getClaimAttachmentDetails();">UAC Cover Letter
                                </button>

                            </div>
                            <div class="row mt-4">
                                <button class="btn blue-btn btn-sm ms-3 col-lg-4"
                                    *ngIf="(isInputOptions.tabsChanges == 'ActiveClaims' || isInputOptions.tabsChanges == 'ArchiveClaims') && isInputOptions.isClaimAttachment"
                                    data-bs-toggle="modal" data-bs-target="#viewAppealRequestFormModal"
                                    (click)="isViewAppealRequestForm=true">Appeal Request Form
                                </button>
                            </div>

                        </div>
                    </div>
                    <!-- Type of Bill(Facility & Frequency Code) -->
                    <span *ngIf="isInputOptions.is87IClaim">
                        <div class="row mt-3">
                            <div class="col-lg-8">
                                <div class="row">
                                    <label class="label">Type of Bill(Facility & Frequency Code)</label>
                                    <input type="text" class="ms-2 form-control col-lg-1" [disabled]="showEditorView"
                                        [(ngModel)]="ProfessionClaimList.facility" />
                                    <input type="text" class="ms-2 form-control col-lg-1" [disabled]="showEditorView"
                                        [(ngModel)]="ProfessionClaimList.frequncyCode" />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <label class="label">Statement Covers Period</label>
                                    <input type="text" class="ms-2 form-control col-lg-3" [disabled]="true"
                                        [(ngModel)]="startserviceDate" />
                                    <hr class="ms-1"
                                        style="width:10px;color: #817c7c;background-color: #7f7c7c;height: 1px;" />
                                    <input type="text" class="ms-2 form-control col-lg-3" [disabled]="true"
                                        [(ngModel)]="ensserviceDate" />
                                </div>
                            </div>
                        </div>
                        <!-- Admission / Discharge -->
                        <label class="subs">Admission / Discharge</label>
                        <hr class="mt-0" />
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Admission
                                                Date</label>
                                            <my-date-picker class="col-lg-7 col-md-5 col-sm-12 col-xs-12 pr-0 pl-0"
                                                [options]="myDatePickerOptions"
                                                (dateChanged)="onAdmissionDateChanged($event)"
                                                (inputFieldChanged)="Admissiondatechange($event)"
                                                placeholder="mm/dd/yyyy" [selDate]="ProfessionClaimList.admissionDate"
                                                [disabled]="showEditorView">
                                            </my-date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Admission
                                                Hours(HHMM)</label>
                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.admissionHour"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Priority (Type) of
                                                Admission</label>
                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.priorityTypeOfAdmission"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Point of Origin
                                                for
                                                Admission or
                                                Visit</label>
                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.pointOfOriginForAdmissionOrVisit"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Patient Discharge
                                                Status</label>
                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.patientDischargeStatus"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="row">
                                            <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Discharge
                                                Hours(HHMM)</label>
                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.dischargeHour"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- Physician Details -->
                        <label class="subs">Physician Details</label>
                        <hr class="mt-0" />
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="row">
                                    <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Last Name</label>
                                    <input type="text" class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                        [(ngModel)]="ProfessionClaimList.physician_LastName"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">First Name</label>
                                    <input type="text" class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                        [(ngModel)]="ProfessionClaimList.physician_FirstName"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">Middle Name</label>
                                    <input type="text" class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                        [(ngModel)]="ProfessionClaimList.physician_MiddleName"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <label class="label col-lg-4 col-md-4 col-sm-6 col-xs-12">NPI</label>
                                    <input type="text" class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                        [(ngModel)]="ProfessionClaimList.physician_NPI" [disabled]="showEditorView" />
                                </div>
                            </div>

                        </div>
                    </span>
                    <!-- Subscriber -->
                    <label class="subs">Subscriber</label>
                    <hr class="mt-0" />
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">First Name</label>
                                        </div>
                                        <div class="col-lg-7 col-md-5 col-sm-12 col-xs-12">
                                            <input type="text" class="form-control "
                                                [(ngModel)]="ProfessionClaimList.subscriberFirstName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">Middle Name</label>
                                        </div>
                                        <div class="col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberMiddleName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label]">Last Name</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberLastName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">DOB</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <my-date-picker class=" pr-0 pl-0" [options]="myDatePickerOptions"
                                                (dateChanged)="onDateChanged($event)"
                                                (inputFieldChanged)="DOBdatechange($event)" placeholder="mm/dd/yyyy"
                                                [selDate]="ProfessionClaimList.subscriberDOB"
                                                [disabled]="showEditorView">
                                            </my-date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">Gender</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <select value="Gender" class="form-control" style="display: flex;"
                                                [(ngModel)]="ProfessionClaimList.subscriberGenderLid"
                                                [disabled]="showEditorView">
                                                <option [value]="st.id" *ngFor="let st of genderList">
                                                    {{ st.lovName }}
                                                </option>
                                            </select>
                                            <app-dropdown *ngIf="!showEditorView"
                                                (EmitRefreshClick)="refreshToGetDropDownValues('GENDER')"></app-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">Member Id</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <input type="text"
                                                class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberMemberID"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label ">Refferal#</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberRefferal"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">Prior Auth#</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">


                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberPriorAuth"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-6 col-sm-12 col-xs-12">

                                            <label class="label">Apt</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-5 col-sm-12 col-xs-12">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.client_Apt"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                                    <label class="label">Address Line 1</label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.subscriberAddressLine1"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                                    <label class="label">Address Line 2</label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.subscriberAddressLine2"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="row p-0">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label">City</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberCity"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label">State</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberState"
                                                [disabled]="showEditorView" maxlength="2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label">ZIP Code</label>
                                        </div>
                                        <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberZIPCode"
                                                [disabled]="showEditorView" minlength="5" maxlength="10"
                                                (keypress)="keyPress($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <button class="btn blue-btn btn-sm mb-1 mt-1" type="button"
                                            [disabled]="showEditorView" (click)="getzipcodeSUbscriber()">
                                            Get Zip
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label">Phone</label>
                                        </div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberPhone"
                                                (ngModelChange)="PhoneFormat()" minlength="14" maxlength="14"
                                                (keypress)="keyPress($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label">Email</label>
                                        </div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text" class="form-control"
                                                [(ngModel)]="ProfessionClaimList.subscriberEmail"
                                                [disabled]="showEditorView"
                                                (keypress)="global.preventforSpace($event)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Provider Information -->
                    <label class="subs mt-3">Provider Information</label>
                    <hr class="mt-0" />
                    <!-- Billing Provider: -->
                    <div class="row">
                        <div class="col-lg-6">
                            <label class="label">Billing Provider: </label><br />
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label">NPI</label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingNPI" [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                
                                        <label class="label ">Provider #</label></div>

                                        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingProvider"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label ">Tax ID</label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingTaxID"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                
                                        <label class="label">Organization</label>
                                        </div>
                                        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 ">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingOrganization"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="  col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label">Taxnomy Code</label>
                                        </div>
                                
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                
                                        <input type="text" class=" form-control"
                                            [(ngModel)]="ProfessionClaimList.companyTaxnomyCode"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                                    <label class="label">Address Line 1</label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.billingAddressLine1"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                                    <label class="label">Address Line 2</label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.billingAddressLine2"
                                        [disabled]="showEditorView" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class=" col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label">City</label>
                                        </div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingCity" [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label ">State</label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control "
                                            [(ngModel)]="ProfessionClaimList.billingState" [disabled]="showEditorView"
                                            maxlength="2" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                
                                        <label class="label">ZIP Code</label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.billingZIPCode" [disabled]="showEditorView"
                                            minlength="5" maxlength="10" (keypress)="keyPress($event)" />
                                            </div>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                    <button class="btn blue-btn btn-sm mb-1  mt-1" type="button"
                                        [disabled]="showEditorView" (click)="getzipcodeBilling()">
                                        Get Zip
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <hr /> -->
                    <!-- Rendering Provider: -->
                    <span *ngIf="!isInputOptions.is87IClaim">
                        <div class="row" style="white-space: pre"
                            *ngIf="ProfessionClaimList.renderingProviderCode != 'NOID'">
                            <div class="col-lg-12">
                                <label class="label">Rendering Provider:</label><br />
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class=" col-lg-5 col-md-5 col-sm-6 col-xs-12">
                                                <label class="label">First Name</label>
                                            </div>
                                            <div class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 ">

                                                <input type="text" class="form-control"
                                                    [(ngModel)]="ProfessionClaimList.renderingFirstName"
                                                    [disabled]="showEditorView" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class=" col-lg-5 col-md-5 col-sm-6 col-xs-12">

                                                <label class="label c">Last Name</label>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                                <input type="text" class="form-control"
                                                    [(ngModel)]="ProfessionClaimList.renderingLastName"
                                                    [disabled]="showEditorView" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12">

                                                <label class="label ">Middle Name</label>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                                <input type="text"
                                                    class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-control"
                                                    [(ngModel)]="ProfessionClaimList.renderingMiddleName"
                                                    [disabled]="showEditorView" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class=" col-lg-5 col-md-5 col-sm-6 col-xs-12">

                                                <label class="label">Taxnomy Code</label>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                                <input type="text" class=" form-control"
                                                    [(ngModel)]="ProfessionClaimList.groupPayorTaxnomyCode"
                                                    [disabled]="showEditorView" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                                <label class="label ">NPI</label>
                                            </div>
                                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">

                                                <input type="text" class=" form-control"
                                                    [(ngModel)]="ProfessionClaimList.renderingNPI" [disabled]="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">

                                            <label class="label ">Provider #</label></div>
                                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">

                                            <input type="text"
                                                class="form-control"
                                                [(ngModel)]="ProfessionClaimList.renderingProvider" [disabled]="
                      showEditorView ||
                      ProfessionClaimList.renderingProvider == null
                    " /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                    <hr *ngIf="ProfessionClaimList.renderingProviderCode != 'NOID'" />
                    <!-- Supervising Provider: -->
                    <label class="subs mt-3" *ngIf="ProfessionClaimList.isSupervisingProvider">Supervising
                        Information</label>
                    <hr class="mt-0 mb-0" *ngIf="ProfessionClaimList.isSupervisingProvider" />
                    <span *ngIf="ProfessionClaimList.isSupervisingProvider">
                        <div class="row" style="white-space: pre">
                            <!-- <div class="col-lg-12">
                        <label class="label ms-0">Supervising Provider:</label><br />
                    </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">First Name</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.supervisingProvider_FirstName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Middle Name</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.supervisingProvider_MiddleName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Last Name</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.supervisingProvider_LastName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">RN NPI</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.supervisingProviderRNNPI"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">UMPI</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.supervisingProviderUMPI"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                    <!-- Refering Provider: -->
                    <label class="subs mt-3" *ngIf="ProfessionClaimList.isReferringProvider">Refering
                        Information</label>
                    <hr class="mt-0 mb-0" *ngIf="ProfessionClaimList.isReferringProvider" />
                    <span *ngIf="ProfessionClaimList.isReferringProvider">
                        <div class="row" style="white-space: pre">
                            <!-- <div class="col-lg-12 ms-0">
                        <label class="label">Refering Provider:</label><br />
                    </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">

                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">First Name</label>

                                            <input type="text" class="col col-xs-12 form-control"
                                                [(ngModel)]="ProfessionClaimList.referringProvider_FirstName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Middle Name</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.referringProvider_MiddleName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Last Name</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.referringProvider_LastName"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Refering Provider No</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.referringProvider_NPI"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div>
                                            <label class="label col pl-0 ms-0">Employee UMPI</label>
                                            <input type="text" class="col form-control"
                                                [(ngModel)]="ProfessionClaimList.referringProviderUMPI"
                                                [disabled]="showEditorView" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                    <hr *ngIf="ProfessionClaimList.isReferringProvider" />
                    <!-- Destination Insurance -->
                    <div class="row mt-2">
                        <div class="col-lg-6">
                            <label class="subs">Destination Insurance</label>
                            <hr class="mt-0" />
                        </div>
                        <div class="col-lg-3">
                            <label class="subs">Diagnosis Code</label>
                            <hr class="mt-0" />
                        </div>
                        <div class="col-lg-3">
                            <label class="subs">Place of Service</label>
                            <hr class="mt-0" />
                        </div>
                    </div>
                    <!-- Payer Name -->
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                                 
                                        <label class="label pr-0">Payer
                                            Name</label>
                                            </div>
                                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                 
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.destinationPayerName"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                                 
                                        <label class="label ">Payer ID</label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 ">
                                 
                                        <input type="text" class="form-control"
                                            [(ngModel)]="ProfessionClaimList.destinationPayerId"
                                            [disabled]="showEditorView" />
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="row">
                                <!-- <div class="col"> -->
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                 
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.destinationDiagnosisCode"
                                        (input)="validateNumber($event)" [disabled]="showEditorView" />
                                        </div>
                                <!-- </div> -->
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <input type="text" class="form-control"
                                        [(ngModel)]="ProfessionClaimList.destinationPOS" [disabled]="showEditorView" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Authorization Information -->
                    <label class="subs mt-3">Authorization Information</label>
                    <hr class="mt-0" />
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                  
                                            <label
                                                class="label ">Authorization</label>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  
                                            <input type="text" class="form-control "
                                                [disabled]="true" />
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  
                                            <label class="label ">PWK</label></div>
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                  
                                            <input type="text" class="form-control "
                                                [disabled]="true" />
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class=" col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    
                                            <label class="label">HR</label>
                                            </div>
                                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    
                                            <input type="text"
                                                class="form-control "
                                                [disabled]="true" />
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                   
                                            <label class="label">Certificate of
                                                need</label>
                                                </div>
                                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                   
                                            <input type="text"
                                                class="form-control "
                                                [disabled]="true" />
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                   
                                            <label class="label">Prior
                                                Authorization
                                                #</label></div>
                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                   
                                            <input type="text"
                                                class="form-control "
                                                [disabled]="true" />
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Attachment -->
                    <label class="subs">Attachment</label>
                    <hr class="mt-0 mb-0" />
                    <div class="col-12 pl-1">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-12 ">
                                <label class="label ms-0 pl-0 col">Report Type</label>
                                <ng-select class="" [(ngModel)]="ProfessionClaimList.reportTypeLid"
                                    [items]="reportTypeDeopdownList" [searchable]="true" [clearable]="true"
                                    bindLabel="value" bindValue="key" [disabled]="showEditorView"></ng-select>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 ">
                                <label class="label ms-0 pl-0 col">Txn</label>
                                <ng-select class="" [items]="reportTransmissionList"
                                    [(ngModel)]="ProfessionClaimList.txnLid" [searchable]="true" [clearable]="true"
                                    bindLabel="value" bindValue="key" [disabled]="showEditorView"></ng-select>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 ">
                                <label class="label ms-0 pl-0 col">Control Number</label>
                                <input type="text" class="form-control col"
                                    [(ngModel)]="ProfessionClaimList.controlNumber" [disabled]="showEditorView" />
                            </div>
                        </div>
                    </div>
                    <!-- Service Line Information -->
                    <label class="subs mt-3">Service Line Information</label>
                    <hr class="mt-0" />
                    <div class="row mb-12 ms-1">
                        <button type="button" class="btn blue-btn btn-sm mb-1 col-lg-2" [disabled]="showEditorView"
                            data-bs-toggle="modal" data-bs-target="#markAsPaid" (click)="MakeMarkServicePaid()">
                            Mark As Paid in Full
                        </button>
                        <button type="button" class="btn blue-btn btn-sm ms-2 mb-1  col-lg-2" [disabled]="showEditorView"
                            data-bs-toggle="modal" data-bs-target="#paidAmountUpdateSModal"
                            (click)="editPaidAmount();isManuallyPost=false">
                            Update Paid Amount
                        </button>

                        <button type="button" class="btn blue-btn btn-sm ms-2 mb-1  col-lg-2" [disabled]="showEditorView"
                            data-bs-toggle="modal" data-bs-target="#creattimesheet" (click)="addtimesheetdata()">
                            Add Timesheet
                        </button>
                        <button type="button" class="btn blue-btn btn-sm ms-2 mb-1  col-lg-2" [disabled]="showEditorView"
                            data-bs-toggle="modal" (click)="updatetimesheet()">
                            Update Timesheet
                        </button>
                        <button type="button" class="btn blue-btn btn-sm ms-2 mb-1  col-lg-2" [disabled]="showEditorView"
                            data-bs-toggle="modal" data-bs-target="#paidAmountUpdateSModal"
                            (click)="editPaidAmount();isManuallyPost=true">
                            Manually Post Payment
                        </button>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <ejs-grid #gridservicLine [dataSource]='ProfessionClaimList.serviceDetailsList'
                                [allowResizing]='true' [allowReordering]="true" [showColumnChooser]='true'>
                                <e-columns>
                                    <e-column field="fromDate" headerText="Service Date" [width]=130 type="date"
                                        [format]="formatOptions">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="code" headerText="Code" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="modifier1" headerText="Mod 1" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="modifier2" headerText="Mod 2" [width]=130 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="modifier3" headerText="Mod 3" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="revCode" headerText="Rev Code" [width]=100 type="string"
                                        [visible]="isInputOptions.is87IClaim">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="totalUnits" headerText="Units" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="dailyHours" headerText="Total Hours" [width]=130 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="actualGrossCharges" headerText="Gross Charge" [width]=100
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="actualNetCharges" headerText="Net Charge" [width]=130
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="totalCharge" headerText="Total Charge" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="postedDate" headerText="Posted Date" [width]=100 type="date"
                                        [format]="formatOptions">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="paidDate" headerText="Payer Paid Date" [width]=100 type="date"
                                        [format]="formatOptions">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="payerPaid" headerText="Payer Paid" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="denialCode" headerText="Denial Code" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="overBilled" headerText="Overbilled (CO 45)" [width]=100
                                        type="number">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="spendDownCharges" headerText="SpendDown charge" [width]=100
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="spendDownPaid" headerText="SpendDown Paid" [width]=100
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="spendDownPaidDate" headerText="SpendDown Paid Date" [width]=100
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="paidAmount" headerText="Total Paid" [width]=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="balanceDue" headerText="Total Balance Due" [width]=100
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column [width]=100 uid="action" headerText="Actions" textAlign="center"
                                        [showInColumnChooser]='false'>
                                        <ng-template #template let-data>
                                            <button *ngIf="data.spendDownId != null && data.spendDownId != 0"
                                                class="btn btn-edit-table mr-2" [disabled]="showEditorView"
                                                (click)="editSpendDown(data.spendDownId,'edit')">
                                                <i class="fa fa-edit mr-2"></i>SpendDown
                                            </button>
                                            <button class="btn btn-delete-table" [disabled]="showEditorView"
                                                data-bs-toggle="modal" data-bs-target="#deletemodal"
                                                (click)="deleteServiceLine(data)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </ng-template>
                                    </e-column>
                                    <e-column [width]=50 [showInColumnChooser]="false">
                                        <ng-template #headerTemplate let-data>
                                            <div class="d-none d-lg-block">
                                                <span id="show" (click)="show()"><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true">
                                                    </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<!-- app-timesheetverification -->
<span id="openupdatetimesheet" data-bs-target="#updatetimesheetmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="updatetimesheetmodal" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Update Timesheet</h5>
                <button type="button" class="close" (click)="closeUpdateTimesheet()">
                    &times;
                </button>
            </div>
            <div class="modal-body scroll">
                <app-timesheetverification [fromClaim]="timesheetVerificationInput" *ngIf="openverification"
                    (outclaim)="fromtimesheetverification($event)">
                </app-timesheetverification>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="closeUpdateTimesheet()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
<!-- markAsPaid -->
<span id="openMarkPaidModal" data-bs-target="#markAsPaid" data-bs-toggle="modal"></span>
<div class="modal fade" id="markAsPaid" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Pay details</h5>
                <button type="button" class="close" data-bs-dismiss="modal">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="markAsPaidForm">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="center-block col-lg-3 col-md-3 col-sm-12 col-xs-12">Paid Date<sup
                                        class="super-script">*</sup></label>
                                <my-date-picker class=" col-lg-7 col-md-7 col-sm-12 col-xs-12" name="nmapaiddate"
                                    [options]="myDatePickerOptions" [selDate]="Markaspaidlist.paidDate"
                                    formControlName="mapaiddate" (inputFieldChanged)="MarkPaiddatechange($event)"
                                    (dateChanged)="onMarkPaidDateChanged($event)" required>
                                </my-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="center-block col-lg-3 col-md-3 mb-0 col-sm-12 col-xs-12">Type of pay<sup
                                        class="super-script">*</sup></label>
                                <input type="radio" [value]="'net'" class=" ms-3" [(ngModel)]="Markaspaidlist.typeofPay"
                                    formControlName="typeofpay" />&nbsp;&nbsp;Net
                                charges
                                <input type="radio" [value]="'gross'" class=" ms-4"
                                    [(ngModel)]="Markaspaidlist.typeofPay"
                                    formControlName="typeofpay" />&nbsp;&nbsp;Gross Charges
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn blue-btn btn-sm" (click)="MarkServicePaid()"
                            [disabled]="!markAsPaidForm.valid">
                            <span> Save & Close</span>
                        </button>
                        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!--  creattimesheet-->
<span id="opencreatetimesheet" data-bs-target="#creattimesheet" data-bs-toggle="modal"></span>
<div class="modal fade" id="creattimesheet" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Create Timesheet</h5>
                <button type="button" class="close" data-bs-dismiss="modal">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Service Date <sup class="super-script">&nbsp; *</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker name="servicedate" placeholder="mm/dd/yyyy"
                            [options]="myDatePickerOptionsheader" [selDate]="timesheetserviceDate"
                            (inputFieldChanged)="servicedatechange($event)" (dateChanged)="serviceDateChanged($event)"
                            required>
                        </my-date-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-5">
                        <label>Total Hours<sup class="super-script">&nbsp; *</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" [(ngModel)]="totalhours" class="form-control "
                            (keypress)="numberonly($event)" />
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn blue-btn btn-sm" (click)="savetimesheet()" [disabled]="
              timesheetserviceDate == null ||
              timesheetserviceDate == '' ||
              totalhours == null ||
              totalhours == ''
            ">
                        <span> Save & Close</span>
                    </button>
                    <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-----------------------------------Claim Service Line Paid Details------------------------------------>
<span id="paidAmountUpdateSModalSpan" data-bs-toggle="modal" data-bs-target="#paidAmountUpdateSModal"></span>
<div class="modal fade" id="paidAmountUpdateSModal" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">

                <h5 class="modal-title font-header" *ngIf="!isManuallyPost">Claim Service Line Paid Details</h5>
                <h5 class="modal-title font-header" *ngIf="isManuallyPost">Manually Post Payment Details</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                        <div class="table-responsive">
                            <table class="tableclass table-hover table-bordered">
                                <thead>
                                    <tr class="row1" style="text-align: center">
                                        <th class="pointer"
                                            style="min-width: 100px;position: relative;color:white;background-color:  #00786a;">
                                            Service Date</th>
                                        <th class="pointer" style="min-width: 70px">Code</th>
                                        <th class="pointer" style="min-width: 50px">Mod 1</th>
                                        <th class="pointer" style="min-width: 50px">Mod 2</th>
                                        <th class="pointer" style="min-width: 50px">Mod 3</th>
                                        <th class="pointer" style="min-width: 70px">Units</th>
                                        <th class="pointer" style="min-width: 80px">Gross Charge</th>
                                        <th class="pointer" style="min-width: 80px">Net Charge</th>
                                        <th class="pointer" style="min-width: 120px">Paid Date</th>
                                        <th class="pointer" style="min-width: 80px">Paid Amount</th>
                                        <th *ngIf="isManuallyPost" class="pointer" style="min-width: 120px">
                                            OverBilledAmount</th>
                                        <th *ngIf="isManuallyPost" class="pointer" style="min-width: 80px">
                                            SpendownCharge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="row1" *ngFor="let pc of claimServiceLines  let i=index">
                                        <td class="tab"
                                            style="text-align: left;position: relative;background-color: whitesmoke;">
                                            {{ pc.fromDate | date: "MM/dd/yyyy" }}
                                        </td>
                                        <td class="tab" style="text-align: left">{{ pc.code }}</td>
                                        <td class="tab" style="text-align: left">{{ pc.modifier1 }}</td>
                                        <td class="tab" style="text-align: left">{{ pc.modifier2 }}</td>
                                        <td class="tab" style="text-align: left">{{ pc.modifier3 }}</td>
                                        <td class="tab" style="text-align: left">{{ pc.totalUnits }}</td>
                                        <td class="tab" style="text-align: left">
                                            {{ pc.actualGrossCharges }}
                                        </td>
                                        <td class="tab" style="text-align: left">{{ pc.actualNetCharges }}</td>
                                        <td class="tab" style="text-align: left">
                                            <my-date-picker [options]="myDatePickerOptions"
                                                [selDate]="pc.paidDateFormated" placeholder="mm/dd/yyyy"
                                                (inputFieldChanged)="paidChange($event, pc)"
                                                (dateChanged)="onPaiddatechanged($event, pc)">
                                            </my-date-picker>
                                        </td>
                                        <td class="tab" style="text-align: left">
                                            <input type="string" (keypress)="decimalOnly($event)"
                                                [(ngModel)]="pc.payerPaid" />

                                        </td>
                                        <td *ngIf="isManuallyPost" class="tab" style="text-align: left">
                                            <input type="string" (keypress)="decimalOnly($event)"
                                                [(ngModel)]="pc.overBilledAmount" />
                                        </td>
                                        <td *ngIf="isManuallyPost" class="tab" style="text-align: left">
                                            <input type="string" (keypress)="decimalOnly($event)"
                                                [(ngModel)]="pc.spendownCharge" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn blue-btn btn-sm" (click)="updatePaidAmount()">
                    Update & Close
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!--Edit Spendown  -->
<span id="openSpendDownDetails" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"></span>
<div class="modal fade" id="SpendDownDetails" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Spenddown details</h5>
                <button type="button" class="close" data-bs-dismiss="modal">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="SpendDownForm">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                                <label class="center-block ">Invoice Date</label>
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                               
                                <label>{{
                                    spendDownDetails?.invoiceDate | date: "MM/dd/yyyy"
                                    }}</label>
                                    </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                               
                                <label class="center-block ">Invoice Number</label></div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                               
                                <label>{{ spendDownDetails?.invoiceNumber }}</label></div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                               
                                <label class="center-block">Total Amount</label></div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                               
                                <label>{{ spendDownDetails?.totalAmount }}</label></div>
                            </div>

                            <div class="row">
                                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Balance</label>
                                <label class="col-6 pl-0">{{ spendDownDetails?.balanceAmount | number: '1.2-2' }}</label>
                                <!-- Popover Button -->
                                <button type="button" id="SpendownPaidRecords" class="pt-0 mt-0 col-1 pr-0 border-0 bg-none"
                                  placement="right" [ngbPopover]="popoverSpendDown" popoverTitle="Payment Details" triggers="manual" [autoClose]="false"
                                  #popover="ngbPopover" (click)="popover.toggle()"
                                  *ngIf="spenDownPaidHistory != undefined && spenDownPaidHistory.length > 0">
                                  <p><span class="w-badge w-red">{{spendownhistorycount}}</span></p></button>
                              </div>
                              <!-- Popover Content -->
                              <ng-template #popoverSpendDown>
                                <div class="container position-relative">
                                  <!-- Payment Details Section -->
                                  <div class="row">
                                    <label class="col-6 pr-0">
                                      <span class="font-bold">Total Amount:</span>
                                      {{ spendDownDetails?.totalAmount | number: '1.2-2' }}
                                    </label>
                                    <label class="col-6">
                                      <span class="font-bold">Balance:</span>
                                      {{ spendDownDetails?.balanceAmount | number: '1.2-2' }}
                                    </label>
                                  </div>
                                  <div class="table-responsive mt-2" style="max-height: 450px; overflow-y: auto;">
                                    <table class="table table-bordered" >
                                      <thead>
                                        <tr>
                                          <th class="text-left">Action</th>
                                          <th class="text-left">Paid Date</th>
                                          <th class="text-center">Paid Amount</th>
                                          <th class="text-center">Check Number</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let ele of spenDownPaidHistory">
                                          <td class="text-center">
                                            <button class="btn btn-sm ml-2 text-danger" (click)="deleteSpendownHistory(ele)">
                                              <i class="fa fa-trash fa-lg"></i>
                                            </button>
                                          </td>
                                          <td class="text-center">{{ ele.paidDate | date: 'MM/dd/yyyy' }}</td>
                                          <td class="text-center">{{ ele.paidAmount | number: '1.2-2' }}</td>
                                          <td class="text-center">{{ ele.checkNumber }}</td>
                                        </tr>
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td class="text-center font-bold"></td>
                                          <td class="text-center font-bold"></td>
                                          <td class="text-center font-bold">Total : {{ totalSpendDownPaidAmount | number: '1.2-2' }}</td>
                                          <td class="text-center font-bold"></td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                  <!-- <div class="row">
                                    <div class="ml-auto mr-3">
                                      <button type="button" class="btn blue-btn btn-sm" (click)="closePopover(popover)">
                                        Close
                                      </button>
                                    </div>
                                  </div> -->
                                  
                                </div>
                              </ng-template>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                               
                                <label class="center-block ">Paid Date<sup
                                        class="super-script">*</sup></label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                <my-date-picker class="pl-0 pr-0 "
                                    name="nmapaiddate" [options]="myDatePickerOptions"
                                    [selDate]="spendDownDetails.formatedPaidDate" formControlName="spendPaidDate"
                                    (inputFieldChanged)="SpendPaiddatechange($event)"
                                    (dateChanged)="onSpendPaiddatechanged($event)" required>
                                </my-date-picker>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                               
                                <label class="center-block ">Paid Amount<sup
                                        class="super-script">*</sup></label></div>
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    
                                <input type="number" [(ngModel)]="this.spendDownDetails.paidAmount"
                                    formControlName="spendpaidAmount" class="form-control " />
                                    </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn blue-btn btn-sm" (click)="UpdateSpendDown()"
                    [disabled]="SpendDownForm.invalid">
                    <span> Save & Close</span>
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!---------------------------------------------delete service line----------------->
<span id="openModal4" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteServiceLineConfirm()">
                    Delete
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Loader -->



<!------------------------Claim History Modal----------------->
<span id="openClaimHistory" data-bs-target="#claimHistoryModal" data-bs-toggle="modal"></span>
<div class="modal" id="claimHistoryModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Claim History</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div>
                    <ejs-grid #gridHistory [dataSource]="claimHistoryData" [allowPaging]="true" [allowSorting]="true"
                        [pageSettings]="pageSettings" [allowResizing]='true'>
                        <e-columns>
                            <e-column headerText="Action" textAlign="Center" width="80" [allowFiltering]="false"
                                [allowSorting]="false">
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table text-center" [disabled]="data.id==0"
                                        (click)="getseparateClaimDetails(data)"><i class="fa fa-eye"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column field='reprocessedDate' headerText="Date of Reprocessed" type='date'
                                [format]="gridDateFormat" minwidth=60></e-column>
                            <e-column field='reSubmissionCode' headerText="Resubmission code" type='text'
                                minwidth=60></e-column>
                            <e-column field='payerClaimControl' headerText="Payer Claim Control #" type='text'
                                minwidth=60></e-column>
                            <e-column field='fileName' headerText="File Name" type='text' minwidth=60></e-column>
                            <e-column field='user' headerText="User" minwidth=60></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div>
                    <div *ngIf="claimHistoryData.length == 0" class="text-center" style="color:red">
                        <p>No data available</p>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>


<!-- View Every Claim History Details -->
<span id="openViewClaimHistory" data-bs-target="#viewViewImportClaimModal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="viewViewImportClaimModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog1 modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-left font-header">835 Record</h5>
                <button class="text-right btn blue-btn btn-sm ms-5" (click)="kendopdfdownloadList()"
                    *ngIf="!isEemptyImportClaim">
                    Download
                </button>
                <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row justify-content-center">
                    <p style="color:red" *ngIf="isEemptyImportClaim"> No Imported File</p>
                </div>
            </div>
            <div class="modal-body modal-body1" *ngIf="!isEemptyImportClaim">
                <div class="row">
                    <div class="col-lg-12">
                        <kendo-pdf-export #pdflist paperSize="A4">
                            <div style="width:700px">
                                <ng-container *ngFor="let val of View835Claim">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <label style="font-weight: 600">File Name:</label>
                                                </div>
                                                <div class="col-lg-8">
                                                    <label>{{val.fileName}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div class="row">
                                                <div class="col-lg-5">
                                                    <label style="font-weight: 600">Imported Date:</label>
                                                </div>
                                                <div class="col-lg-7">
                                                    <label>{{val?.importedDate |date: "MM/dd/yyyy"}}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr style="
                      margin-top: 1.5%;
                      border-top: 1px solid rgb(19, 17, 17);
                      width: 100%;
                      box-shadow: 0px 1px 1px #0c0c0c;
                      " />
                                    <div class="row">
                                        <div class="col">
                                            <b>Total Units:</b> {{this.TotalUnits}}
                                        </div>
                                    </div>
                                    <ng-container *ngFor="let transaction of val.transaction835s">
                                        <div class="row">
                                            <div class="col-lg-4">
                                                <div class="font-weight-bold">{{transaction.payorDetail.payorName}}
                                                </div>
                                                <div class="font-weight-bold">{{transaction.payorDetail.payorStreet}}
                                                </div>
                                                <div class="font-weight-bold">{{transaction.payorDetail.payorCity}}
                                                </div>
                                                <div class="font-weight-bold">
                                                    {{transaction.payorDetail.payorState}},{{transaction.payorDetail.payorZiPCode}}
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="font-weight-bold">{{transaction.companydetails.companyName}}
                                                </div>
                                                <div class="font-weight-bold">
                                                    {{transaction.companydetails.companyAddress}}</div>
                                                <div class="font-weight-bold">{{transaction.companydetails.companyCity}}
                                                </div>
                                                <div class="font-weight-bold">
                                                    {{transaction.companydetails.companyState}},{{transaction.companydetails.companyZip}}
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="font-weight-bold">Payment
                                                    Method:{{transaction.paymentDetail.payment_Method}}</div>
                                                <div class="font-weight-bold">Chk/EFT NBR
                                                    :{{transaction.paymentDetail.check_EFT_NBR }}</div>
                                                <div class="font-weight-bold">Check EFT
                                                    date:{{transaction?.paymentDetail.chk_EFT_date| date:
                                                    "MM/dd/yyyy"}}</div>
                                                <div class="font-weight-bold">Remittance
                                                    Amount:{{transaction.paymentDetail.remittance_Amount}}
                                                </div>
                                            </div>
                                        </div>
                                        <ng-container *ngFor="let patientClaim of transaction?.patient_ClaimDetails">
                                            <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />

                                            <div class="row">
                                                <div class="col-lg-5">
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label style="font-weight: 600">Patient:</label>
                                                        </div>
                                                        <div class="col-lg-8">
                                                            <label>{{patientClaim.patient}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label style="font-weight: 600">HIC:</label>
                                                        </div>
                                                        <div class="col-lg-8">
                                                            <label>{{patientClaim.hic}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label style="font-weight: 600">Pat Ctrl:</label>
                                                        </div>
                                                        <div class="col-lg-8">
                                                            <label>{{patientClaim.patCtrl}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-lg-5">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label style="font-weight: 600">Payor Claim Number:</label>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label>{{patientClaim.payor_Claim_Number}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label style="font-weight: 600">From Date:</label>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label>{{patientClaim?.fromDate |date:
                                                                "MM/dd/yyyy"}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label style="font-weight: 600">To Date:</label>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label>{{patientClaim?.toDate |date: "MM/dd/yyyy"}}</label>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row w-100">
                                                <div class="col-lg-2">
                                                    Service Date
                                                </div>
                                                <!-- <div class="col-lg-1">
                          POS
                        </div> -->
                                                <div class="col-lg-1">
                                                    Units
                                                </div>
                                                <div class="col-lg-1">
                                                    Service
                                                </div>
                                                <div class="col-lg-1">
                                                    MOD
                                                </div>
                                                <div class="col-lg-1">
                                                    Billed
                                                </div>
                                                <div class="col-lg-2">
                                                    Notes
                                                </div>
                                                <div class="col-lg-3">
                                                    DenialDetail
                                                </div>
                                                <div class="col-lg-1">
                                                    Payment
                                                </div>
                                            </div>
                                            <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />
                                            <ng-container *ngFor="let val1 of patientClaim.serviceLineDetail">
                                                <div class="row w-100">
                                                    <div class="col-lg-1">
                                                        {{val1.serviceDate|date:'MM/dd/yyyy'}}
                                                    </div>
                                                    <div class="col-lg-1">

                                                    </div>
                                                    <div class="col-lg-1">
                                                        {{val1.unit}}
                                                    </div>
                                                    <div class="col-lg-1">
                                                        {{val1.servicecode}}
                                                    </div>
                                                    <div class="col-lg-1">
                                                        {{val1.mod}}
                                                    </div>
                                                    <div class="col-lg-1">
                                                        {{val1.billedAmt}}
                                                    </div>
                                                    <div class="col-lg-2 pr-0">
                                                        {{val1.notes}}
                                                    </div>
                                                    <div class="col-lg-3 ">
                                                        {{val1.denied_Detail}}
                                                    </div>

                                                    <div class="col-lg-1">
                                                        {{val1.claimed_Amt}}
                                                    </div>



                                                </div>
                                            </ng-container>
                                            <br>
                                            <div class="row w-100">
                                                <div class="col-lg-2 mt-3">
                                                    <div class="mt-1">{{patientClaim.patient}}</div>
                                                </div>
                                                <div class="col-lg-1 mt-1">
                                                    <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                                                    {{patientClaim.totalUnit}}
                                                </div>
                                                <div class="col-lg-1 mt-3">
                                                    <div class="mt-1"> PtResp:</div>
                                                </div>
                                                <div class="col-lg-1 mt-3">
                                                    <div></div>
                                                    <div class="mt-1"> {{patientClaim.totalPtRespAmt}}</div>
                                                </div>
                                                <!-- <div class="col-lg-1">
                            </div> -->
                                                <div class="col-lg-1 mt-1">
                                                    <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                                                    {{patientClaim.totalBilledAmt}}
                                                </div>
                                                <div class="col-lg-5">
                                                </div>
                                                <!-- &nbsp; -->
                                                <div class="col-lg-1 ">
                                                    <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              text-align: center;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                                                    <div> {{patientClaim.totalClaimAmt}}</div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <hr style="
                        margin-top: 1.5%;
                        border-top: 1px solid rgb(19, 17, 17);
                        width: 100%;
                        text-align: center;
                        box-shadow: 0px 1px 1px #0c0c0c;
                        " />
                                    </ng-container>
                                </ng-container>
                            </div>
                            <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                                <div class="kendofooter">
                                    <hr style="
                  margin-top: 1.5%;
                  border-top: 1px solid rgb(19, 17, 17);
                  width: 100%;
                  box-shadow: 0px 1px 1px #0c0c0c;
                  " />
                                    <div> Exception notes: Note 1: The full payment was not made on this service line.
                                    </div>
                                    <div> Note 2: Something has already been paid on this.</div>
                                    <div> Note 3: The payment amount is less than zero.</div>
                                    <div> Note 4.This is an old format submit claim id, cannot auto-post</div>
                                </div>
                            </ng-template>
                        </kendo-pdf-export>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-bs-dismiss="modal">Cancel</button>
            </div>

        </div>
    </div>
</div>

<!-- Appeal Request Form  Modal -->
<span id="AppealRequestFormModalOpen" data-bs-target="#viewAppealRequestFormModal" data-bs-toggle="modal"></span>
<div class="modal" id="viewAppealRequestFormModal" data-bs-backdrop="static">
    <div class="modal-dialog" role="document" style="max-width:796.8px;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" *ngIf="isViewAppealRequestForm">Appeal Request Form</h5>
                <h5 class="modal-title font-header" *ngIf="isViewUACCoverLetter">UAC Cover Letter</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="isViewAppealRequestForm=false;isViewUACCoverLetter=false">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12" *ngIf="isViewAppealRequestForm">
                        <app-appeal-request-form *ngIf="isViewAppealRequestForm"></app-appeal-request-form>
                    </div>
                    <div class="col-12" *ngIf="isViewUACCoverLetter">
                        <app-uac-coversheet *ngIf="isViewUACCoverLetter"></app-uac-coversheet>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="isViewAppealRequestForm=false;isViewUACCoverLetter=false">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>